import { H6, Image, LI, Progressbar, UL } from "../../../../AbstractElements";
import { activeUsersCountriesData } from "../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";
import { dynamicImage } from "../../../../Service";

const ActiveUsersCountries = () => {
  return (
    <div className="countries">
      <UL className="simple-list">
        {activeUsersCountriesData.map((data, i) => (
          <LI className="d-flex gap-2" key={i}>
            <Image src={dynamicImage(`dashboard-2/flag/${data.image}`)} alt="user" />
            <div className="flex-grow-1">
              <H6 className="f-w-600 mb-1">{data.name}</H6>
              <Progressbar value={data.progressValue} color="primary" />
            </div>
            <span>{data.progressValue}%</span>
          </LI>
        ))}
      </UL>
    </div>
  );
};

export default ActiveUsersCountries;
